<template>
    <validation-provider :name="name" :vid="vid" :rules="rules" v-slot="validationContext">
        <b-form-group :label="label">
            <b-form-input
                @input="updateValue"
                :placeholder="placeholder"
                :disabled="disabled"
                :value="value"
                :step="step ? step : 0.01"
                :type="type ? type : 'text'"
                :state="valid(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
    </validation-provider>
</template>

<script>
    export default {
        name: "ValidInput",
        props: ['rules', 'name', 'value', 'label', 'vid', 'type', 'placeholder', 'step', 'disabled'],
        methods: {
                updateValue: function (value) {
                this.$emit('input', value)
            }
        }
    }
</script>

<style scoped>

</style>
